import { createReducer } from "@reduxjs/toolkit";

import { TYPES } from "../../common/constants";

const fetchAreasAndSubAreasDone = (_, { payload }) => {
  payload = payload.map((area) => {
    if (typeof area.subAreas !== "string") return area;

    area.subAreas = JSON.parse(area.subAreas);
    return area;
  });
  return [...payload];
};

const changeSequenceAreasAndSubAreasDone = (areas, { payload1, payload2 }) => {
  return areas.map((a) => {
    if (a.id === payload1.id) {
      return payload2;
    } else if (a.id === payload2.id) {
      return payload1;
    }
    return a;
  });
};

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_AREAS_AND_SUB_AREAS]: fetchAreasAndSubAreasDone,
  [TYPES.CHANGE_SEQUENCE_AREAS_AND_SUBAREAS]:
    changeSequenceAreasAndSubAreasDone,
});
